module.exports = __webpack_public_path__ + "img/qrcode.85ccdc22.jpg";